import React, {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet-async';
import styled, {ThemeProvider} from 'styled-components';
import {Router, Route, Switch} from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import theme from './modules/theme';
import history from './modules/history';
import LayoutPage from './pages/layout';
import HomePage from './pages/home';
import 'antd/dist/antd.css';
import 'swiper/swiper.scss'; // core Swiper
import 'swiper/modules/navigation/navigation.scss'; // Navigation module
import 'swiper/modules/pagination/pagination.scss'; // Pagination module
import './scss/main.scss';
import './App.scss';
import './scss/CustomBox.scss';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'react-awesome-lightbox/build/style.css';
import { Lang } from './types';
import {useUpdateEffect} from "ahooks";
import { getNameStatisticGeneralInfo, setLang } from "./slices/storeSlice";
import {IntlProvider, useIntl} from 'react-intl';
import {RootState, AppDispatch} from "./store";



const Background= styled.div`
    background-image: url("${process.env.PUBLIC_URL}/images/bg.png");
    background-repeat: repeat;
`;
const BackgroundMask= styled.div`
    width:100% ;
    height: 100%;
	background-image: linear-gradient(to bottom, rgba(255, 255, 255, 1) , transparent 100%);
    position:absolute;
    top:0;
    left:0;
    z-index:1;
`;

const Main = styled.main`
  height: 100%;
`;




function IntlWrapper(){
    const dispatch: AppDispatch = useDispatch()
    const [locale, setLocale] = useState(undefined)
    const lang: any = useSelector((state: RootState) => state.storeSlice.lang);

    useEffect(() => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let paramLang : Lang = (urlParams.get('lang') ? urlParams.get('lang') : 'zh-MO') as Lang;
        dispatch(setLang(paramLang));
        dispatch(getNameStatisticGeneralInfo());
    },[]);

    useUpdateEffect(() => {
        const fetchData = async() => {
            const resp = await fetch(`${process.env.PUBLIC_URL}/lang/${lang}.json`)
            const data = await resp.json()
            setLocale(data)
        };
        fetchData().catch(console.error);
    },[lang])

    return (
        <>
            {locale ? <IntlProvider messages={locale} locale="zh-MO" defaultLocale="zh-MO">
                {lang && <Appication />}
            </IntlProvider>: <div></div>
            }
        </>
    );
}

function Appication() {
    const intl = useIntl();
    const isMobile: any = useSelector((state: RootState) => state.storeSlice.isMobile);
    const isTablet: any = useSelector((state: RootState) => state.storeSlice.isTablet);
    const lang: any = useSelector((state: RootState) => state.storeSlice.lang);

    const theme = {
        isMobile: isMobile,
        isTablet: isTablet,
        isPTEN: (lang==Lang.enUS||lang==Lang.ptPT)? true : false,
        lang: lang
    };

    return (
        <Router history={history}>
            <Background>
            <BackgroundMask/>
                <ThemeProvider theme={theme}>
                    <Helmet
                        // defer={false}
                        htmlAttributes={{lang: 'zh-MO'}}
                        encodeSpecialCharacters={true}
                        defaultTitle={intl.formatMessage({ id: "title"})}
                        titleTemplate={`%s | ${intl.formatMessage({ id: "title" })}`}
                        titleAttributes={{itemprop: 'name', lang: 'zh-MO'}}
                    >
                    </Helmet>
                    <LayoutPage>
                        <Switch>
                            <Route path={`${process.env.PUBLIC_URL}/Home`}>
                                <HomePage />
                            </Route>
                            <Route path={`${process.env.PUBLIC_URL}/`}>
                                <HomePage />
                            </Route>
                        </Switch>
                    </LayoutPage>
                </ThemeProvider>
            </Background>
        </Router>
    );
}

export default IntlWrapper;

{/*<Switch>*/
}
{/*<RoutePublic*/
}
{/*isAuthenticated={false}*/
}
{/*path="/"*/
}
{/*exact*/
}
{/*to="/private"*/
}
{/*component={Home}*/
}
{/*/>*/
}
{/*<RoutePublic*/
}
{/*isAuthenticated={false}*/
}
{/*path="/Home"*/
}
{/*exact*/
}
{/*to="/private"*/
}
{/*component={Home}*/
}
{/*/>*/
}
{/*<RoutePrivate isAuthenticated={false} path="/private" component={Home} />*/
}
{/*<Route component={NotFound} />*/
}
{/*</Switch>*/
}
